<!--<svelte:head>
  <script src="../src/TIS10.js" />
</svelte:head>-->

<script>
	//import CPU from './CPU.svelte';
	import Problem from './Problem.svelte';
	//import Buttons from './Buttons.svelte';
	//game screen given a specific problem
	export let CurrGameID=0;
	//again, DB or global
	import {LevelsID, NumberOfLevels} from './Levels.svelte';
	import {TIS10} from './TIS10.js';
	import { onMount } from 'svelte';
	//sound
	//https://svelte.dev/repl/b0a901d9a15347bd95466150485e4a78?version=3.31.0
	import { audioData } from './audioData.js';
	//stores
	import { app_theme, cpu_speed, max_speed, user_levels, play_sound, game_over, num_solved, first_time} from './stores.js';
	
	//audio
	//let audioBeep = new Audio(audioData[0].url);
 	//let audioHum = new Audio(audioData[1].url);
	let audioQuantum = new Audio(audioData['quantum'].url);
	let audioError = new Audio(audioData['error'].url);
	let audioBUp = new Audio(audioData['buttonup'].url);
	let audioBDown = new Audio(audioData['buttondown'].url);
	let audioClick = new Audio(audioData['click'].url);
	let audioBzzz = new Audio(audioData['bzzz'].url);
	//let audioButtonclick  = new Audio(audioData[8].url);
	//let audioHumup  = new Audio(audioData[9].url);
	
	//cpu multiplier
	let CPUBase = 10;
	//find current game and pass dictionary
	let CurrentGame = {};
	CurrentGame = LevelsID[String(CurrGameID)];
	
	//display in LCD
	let COUT = '';
	
	//alert(String(play_sound));
	
	//user output bound to variables in problem to write
	let UserU = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' ',' ', ' ',' ', ' ',' ', ' ',' ', ' ',' ', ' '];
	let UserR = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' ',' ', ' ',' ', ' ',' ', ' ',' ', ' ',' ', ' '];
	let UserL = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' ',' ', ' ',' ', ' ',' ', ' ',' ', ' ',' ', ' '];
	let UserD = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' ',' ', ' ',' ', ' ',' ', ' ',' ', ' ',' ', ' '];
    let Uoutdex = 0;
    let Routdex = 0;
    let Loutdex = 0;
    let Doutdex = 0;
	
	//test indices i
	let Uindex = 0;
	let Rindex = 0;
	let Lindex = 0;
	let Dindex = 0;
	
	
	//input test arrays
	let DBGinU = [];
	let DBGinD = [];
	let DBGinL = [];
	let DBGinR = [];
	if(CurrentGame.InPort.search('U') >= 0)
	{
	    DBGinU = CurrentGame.DBGinU.split(',');
	}
	if(CurrentGame.InPort.search('R') >= 0)
	{
	    DBGinR = CurrentGame.DBGinR.split(',');
	}
	if(CurrentGame.InPort.search('L') >= 0)
	{
	    DBGinL = CurrentGame.DBGinL.split(',');
	}
	if(CurrentGame.InPort.search('D') >= 0)
	{ 
	    DBGinD = CurrentGame.DBGinD.split(',');
	}
	//expected output values
	let DBGoutU = [];
	let DBGoutD = [];
	let DBGoutL = [];
	let DBGoutR = [];
	if(CurrentGame.OutPort.search('U') >= 0)
	{
	    DBGoutU = CurrentGame.DBGoutU.split(',');
	}
	if(CurrentGame.OutPort.search('R') >= 0)
	{
	    DBGoutR = CurrentGame.DBGoutR.split(',');
	}
	if(CurrentGame.OutPort.search('L') >= 0)
	{
	    DBGoutL = CurrentGame.DBGoutL.split(',');
	}
	if(CurrentGame.OutPort.search('D') >= 0)
	{ 
	    DBGoutD = CurrentGame.DBGoutD.split(',');
	}
	
	//let gdesc = ">" + CurrentGame.description;
	//make it look like a console
	//gdesc = gdesc.replaceAll('&','<br/>&gt;');
	//<!--<Problem Name={CurrentGame.name} Description={gdesc} DBGin={CurrentGame.DBGin} DBGout={CurrentGame.DBGout}/>-->
	
	let Program = $user_levels[String(CurrGameID)]['program'];
	//{ProgramT.split("\n")}
	//track lines for PC
	let LinePtr = '';
	
	//make textarea non-editable
	//document.getElementById("CPULines").disabled = true;
	//set up in functions
	let ProgramRows;
	//create TIS10 machine
	let Machine = TIS10; //Object.create(TIS10);
	//need to clear buffers
    Machine.Up = null;
    Machine.Down = null;
    Machine.Left = null;
    Machine.Right = null;
    Machine.Acc = 0;
    Machine.Bak = 0;
    Machine.Cycles = 0;
    Machine.IOAccess = 0;
    
    
    
    
	//***************************************************
	//CPU stuff
	//https://www.toptal.com/designers/htmlarrows/math/
	//arrows for ports and colors
	let HollArrDown = '&#8681;';
	let FillArrDown = '&#11015;';
	let HollArrUp = '&#8679;';
	let FillArrUp = '&#11014;';
	let HollArrRight = '&#8680;';
	let FillArrRight = '&#10145;';
	let HollArrLeft = '&#8678;';
	let FillArrLeft = '&#11013;';
	let XArr = '&#9746;';
	//export let ACCVal=0;
	//export let BAKVal=0;
	let LASTVal=0;
	let MODEVal='IDLE';
	let IDLEVal='0\%';
	let UIN = HollArrDown;
	let UOUT = HollArrUp;
	let DIN = HollArrUp;
	let DOUT = HollArrDown;
	let LIN = HollArrRight;  
	let LOUT = HollArrLeft;
	let RIN = HollArrLeft;
	let ROUT = HollArrRight;
	
	
	
	//broken ports color
	let UStyle = "color:#FFFFFF;";
	let RStyle = "color:#FFFFFF;";
	let LStyle = "color:#FFFFFF;";
	let DStyle = "color:#FFFFFF;";
	
	if(CurrentGame.BrokenPort.search('U') >= 0)
	{
	    UStyle = "color:#FF0000;";
	    UIN = XArr;
	    UOUT = XArr;
	}
	if(CurrentGame.BrokenPort.search('R') >= 0)
	{
	    RStyle = "color:#FF0000;";
	    RIN = XArr;
	    ROUT = XArr;
	}
	if(CurrentGame.BrokenPort.search('L') >= 0)
	{
	    LStyle = "color:#FF0000;";
	    LIN = XArr;
	    LOUT = XArr;
	}
	if(CurrentGame.BrokenPort.search('D') >= 0)
	{ 
	    DStyle = "color:#FF0000;";
	    DIN = XArr;
	    DOUT = XArr;
	}
	
	
	
	//broken, hidden messages
	Machine.ErrorPort = CurrentGame.BrokenPort;
	let HiddenIndex = 0;
    
	
	
	//need to bind the elements of the machine
	function UpdateLinePtr()
	{
	    var newlp = '';
	    var t=0;
	    for(t=0; t < Machine.PC; t++)
	        newlp = newlp + '\n';
	    LinePtr= newlp + '>';
	    return;
	}
	//***************************************************
	//Button handlers
	function StopBtn() {
	    //stop sound
	    if ($play_sound)
	        audioBUp.play();
	    
		//stop stuff
		Machine.Running = false;
        //enable textarea again
        document.getElementById("CPUCode").disabled = false;
        //turns led off
        document.getElementById("led_ind").className = "led-red-off";
        //remove code overlay for highlighting
        //document.getElementById("overlay").style.display = "none";
		
		//reset bootstrap for run button
		//need a delay or you get an infinite loop
		setTimeout(function(){Bootstrap=true;},10000);
		return;
	}
	function StepBtn() {
	    
	    //if just step button pushed
	    //if ($play_sound && Bootstrap)
	    //    audioButtonclick.play(); 
	    
	    //if this is the first step
	    if(Machine.Running == false)
	    {
	        //click sound
            if ($play_sound)
            {
                //audioHumup.play();
                audioBzzz.play(); 
            }
            
	        //document.getElementById("overlay").style.display = "block";
	        //set up machine and put in the program
	        ProgramRows = Program.toUpperCase().split("\n");
	        //clear console text
	        COUT = '';
	        //check syntax
	        if(Machine.SyntaxCheck(ProgramRows) == false)
	        {
	            //alert('Code will not compile');
	            COUT = COUT + '&gt;Code will not compile.<br/>';
	            StopBtn();
	            return;
	        }
	        //max rows is 16 and we turn on autoloop
	        Machine.PseudoAssemble(ProgramRows.slice(0,16), true);
	        //make textarea non-editable
	        document.getElementById("CPUCode").disabled = true;
	        document.getElementById("led_ind").className = "led-red-blink";
	        //set test input
	        Uindex = 0;
            Rindex = 0;
            Lindex = 0;
            Dindex = 0;
	         
	        //reset user output
	        UserU = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
            UserR = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
            UserL = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
            UserD = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
            Uoutdex = 0;
            Routdex = 0;
            Loutdex = 0;
            Doutdex = 0;
            
            //reset gui values
            UpdateLinePtr();
	    }
	    else
	    {
	        //click sound
            if ($play_sound)
            {	    

                //audioHum.pause();
                //audioHum = new Audio(audioData[1].url); 
                //audioHum.play();

                audioClick.pause();
                audioClick.play();   
            }
            //get ports from test data
            //only set data if the port is currently null
            if(Machine.Up == null && CurrentGame.InPort.search('U') >= 0 && Uindex < CurrentGame.DBGsize)
            {
                //if dashes are used for delayed input in table
                while(DBGinU[Uindex] == '-' && Uindex < CurrentGame.DBGsize)
                    Uindex++;
                if(Uindex < CurrentGame.DBGsize)
                    Machine.Up = parseInt(DBGinU[Uindex]); //set machine value
                Uindex = Uindex + 1; 
            }
            if(Machine.Right == null && CurrentGame.InPort.search('R') >= 0 && Rindex < CurrentGame.DBGsize)
            {
                while(DBGinR[Rindex] == '-' && Rindex < CurrentGame.DBGsize)
                    Rindex++;
                if(Rindex < CurrentGame.DBGsize)
                    Machine.Right = parseInt(DBGinR[Rindex]); //set machine
                Rindex = Rindex + 1;
            }
            if(Machine.Down == null && CurrentGame.InPort.search('D') >= 0 && Dindex < CurrentGame.DBGsize)
            {
                while(DBGinD[Dindex] == '-' && Dindex < CurrentGame.DBGsize)
                    Dindex++;
                if(Dindex < CurrentGame.DBGsize)
                    Machine.Down = parseInt(DBGinD[Dindex]); //set machine value
                Dindex = Dindex + 1;
            }
            if(Machine.Left == null && CurrentGame.InPort.search('L') >= 0 && Lindex < CurrentGame.DBGsize)
            {
                while(DBGinL[Lindex] == '-' && Lindex < CurrentGame.DBGsize)
                    Lindex++;
                if(Lindex < CurrentGame.DBGsize)
                    Machine.Left =  parseInt(DBGinL[Lindex]); //set machine value
                Lindex = Lindex + 1;
            }
            
            //CHECKING OUTPUT
            //maybe do this as another step
            //update GUI and get port output
            if(Machine.Up != null && CurrentGame.OutPort.search('U') >=0 && Uoutdex < CurrentGame.DBGsize)
            {   //check if the output is correct and writ to table
                if(Machine.Up == parseInt(DBGoutU[Uoutdex]))
                    UserU[Uoutdex] = Machine.Up;
                else
                    UserU[Uoutdex] = '<span style="color:#FF0000">' + Machine.Up + '</span>';
                
                Machine.Up = null; //clear port
                Uoutdex = Uoutdex + 1; //next output index
            }
            if(Machine.Right != null && CurrentGame.OutPort.search('R') >=0 && Routdex < CurrentGame.DBGsize)
            {
                if(Machine.Right == parseInt(DBGoutR[Routdex]))
                    UserR[Routdex] = Machine.Right;
                else
                    UserR[Routdex] = '<span style="color:#FF0000">' + Machine.Right + '</span>';
                
                Machine.Right = null;
                Routdex = Routdex + 1;
            }
            if(Machine.Down != null && CurrentGame.OutPort.search('D') >=0 && Doutdex < CurrentGame.DBGsize)
            {
                if(Machine.Down == parseInt(DBGoutD[Doutdex]))
                    UserD[Doutdex] = Machine.Down;
                else
                    UserD[Doutdex] = '<span style="color:#FF0000">' + Machine.Down + '</span>';
                
                Machine.Down = null;
                Doutdex = Doutdex + 1;
            }
            if(Machine.Left != null && CurrentGame.OutPort.search('L') >=0 && Loutdex < CurrentGame.DBGsize)
            {
                if(Machine.Left == parseInt(DBGoutL[Loutdex]))
                    UserL[Loutdex] = Machine.Left;
                else
                    UserL[Loutdex] = '<span style="color:#FF0000">' + Machine.Left + '</span>';
                
                Machine.Left = null;
                Loutdex = Loutdex + 1;
            }
            
            //finish condition is at least one index is >10, but
            // we also want to make sure if there are multiple outputs they are also done.
            //this way means you can't output all of one port, then all of another
            
            if((Loutdex >= CurrentGame.DBGsize || Doutdex >= CurrentGame.DBGsize || Routdex >= CurrentGame.DBGsize || Uoutdex >= CurrentGame.DBGsize) && ((Loutdex == 0 || Loutdex >= CurrentGame.DBGsize) && (Doutdex == 0 || Doutdex >= CurrentGame.DBGsize) && (Routdex == 0 || Routdex >= CurrentGame.DBGsize) && (Uoutdex == 0 || Uoutdex >= CurrentGame.DBGsize)) && Machine.Running == true)
            {
                StopBtn();
                CheckOutcome();
                LinePtr='';
                return;
            }
            else
            {
                //do a single step
                Machine.Step();
                if(Machine.ErrorFlag == true)
                {
                    HandleError();
                    //stop running the code
                    StopBtn();
                    return;
                }
                UpdateLinePtr();
            }
		}
		UpdateArrows();
		UpdateGUI();
		return;
	}
	
	//if there is an error
	function HandleError()
	{
	    //if sound
        if ($play_sound)
            audioError.play();
	    //alert('Code will not compile');
	    //output error code
        COUT = COUT + '&gt;' + Machine.ErrorString + '<br/>';
        
        //handle secret message 
        //is there one and we only output it once
        if(CurrentGame.Hidden.length > 0 && HiddenIndex < CurrentGame.Hidden.length && Machine.ErrorString.search("READ FROM INVALID PORT")>=0)
        {
            //weird sound
            if ($play_sound)
                audioQuantum.play();

			//get character
            let asciival = String(CurrentGame.Hidden.charCodeAt(HiddenIndex));
			//let asciival = String(CurrentGame.Hidden[HiddenIndex].charCodeAt(0));

			//set port
            if(Machine.ErrorString == "READ FROM INVALID PORT UP")
            	MUp = asciival;
            else if(Machine.ErrorString == "READ FROM INVALID PORT LEFT")
                MLeft = asciival;
            else if(Machine.ErrorString == "READ FROM INVALID PORT DOWN")
                MDown = asciival;
			else if(Machine.ErrorString == "READ FROM INVALID PORT RIGHT")
                MRight = asciival;

			//next char
			//not resetting b/c it's handled in current if statement
			HiddenIndex++;
            
        }
        
        return;
	}
	
	let Bootstrap = true;
	
	function RunBtn() 
	{
        //if(Machine.Running == false && Loutdex <10 && Doutdex < 10 && Routdex < 10 & Uoutdex < 10)
        if(Machine.Running == false && Bootstrap == true)
        {
            //if sound
            if ($play_sound)
                audioBDown.play();
            
            StepBtn();
            Bootstrap = false;
        }
	    //need a timer
		if(Machine.Running && Bootstrap == false)
		{
		    StepBtn();
		    setTimeout(function(){RunBtn();},CPUBase*($max_speed - $cpu_speed));
		    return;
		}
		//StopBtn();
		return;
	}
	
	function PwrBtn() {
		document.getElementById("step_btn").disabled = true; 
		document.getElementById("stop_btn").disabled = true; 
		document.getElementById("run_btn").disabled = true; 
		return;
	}
	
	function CheckOutcome()
	{
	    var good = true;
	    var i=0;
	    if(CurrentGame.OutPort.search('U') >=0)
	    {
	        for(i =0; i < DBGoutU.length; i++)
	        {
	            if(DBGoutU[i] != UserU[i])
	                good = false;
	        }
	    }
	    if(CurrentGame.OutPort.search('R') >=0)
	    {
	        for(i =0; i < DBGoutR.length; i++)
	        {
	            if(DBGoutR[i] != UserR[i])
	                good = false;
	        }
	    }
	    if(CurrentGame.OutPort.search('D') >=0)
	    {
	        for(i =0; i < DBGoutD.length; i++)
	        {
	            if(DBGoutD[i] != UserD[i])
	                good = false;
	        }
	    }
	    if(CurrentGame.OutPort.search('L') >=0)
	    {
	        for(i =0; i < DBGoutL.length; i++)
	        {
	            if(DBGoutL[i] != UserL[i])
	                good = false;
	        }
	    }
	    
	    if(good == true)
	    {
	        COUT = COUT + '&gt;Test successful!<br/>';
	        //update level and open next level
	        $user_levels[String(CurrGameID)]['solved'] = true;
	        $user_levels[String(CurrGameID)]['program'] = Program;
	        if(Machine.Cycles <= $user_levels[String(CurrGameID)]['cycles'] || $user_levels[String(CurrGameID)]['cycles'] == undefined)
	            $user_levels[String(CurrGameID)]['cycles'] = Machine.Cycles;
	        if(Machine.IOAccess <= $user_levels[String(CurrGameID)]['io'] || $user_levels[String(CurrGameID)]['io'] == undefined)
	            $user_levels[String(CurrGameID)]['io'] = Machine.IOAccess;
	        if(Machine.InstructionCount <= $user_levels[String(CurrGameID)]['cmds'] || $user_levels[String(CurrGameID)]['cmds'] == undefined)
	        $user_levels[String(CurrGameID)]['cmds'] = Machine.InstructionCount;
	        //document.getElementById("CPULines").value;
	        
	        //make the next one available
	        //get the order of this one, and finde the next ordered id
	        let ord = CurrentGame.Order + 1;
	        let nextid = 0;
	        //find the next
	        for (let i in LevelsID)
	        {
	            if(LevelsID[i].Order == ord)
	                nextid = LevelsID[i].ID;
	        }
	        //open next puzzle or end game
	        if(nextid != 0 && LevelsID[i].Order < NumberOfLevels)
	            $user_levels[String(nextid)]['available'] = true;
	        else
	        {
	            game_over.set(true);
	            first_time.set(true);
	        }
	        
	        //to open emails and play next voice mail
	        if(CurrentGame.Order > $num_solved)
	        {
	            num_solved.set(CurrentGame.Order);
	            first_time.set(true);
	        }
	    }
	    else
	    {
	        COUT = COUT + '&gt;Test unsuccessful.<br/>';
	         //alert('sorry');   
	    }
	    
	    
        return;
	}

	
	
	onMount(async () => {
		//make textarea non-editable
		document.getElementById("CPULines").disabled = true;
	});
	
	function UpdateArrows()
	{
        //handle arrows
        //up arrows
        if(CurrentGame.BrokenPort.search('U')<0)
        {
            if(Machine.UpArrow == "IN")
                UIN = FillArrDown;
            else if(Machine.UpArrow == "OUT")
                UOUT = FillArrUp;
            else
            {
                UIN = HollArrDown;
                UOUT = HollArrUp;
            }
        }
	    
        //down arrows
        if(CurrentGame.BrokenPort.search('D')<0)
        {
            if(Machine.DownArrow == "IN")
                DIN = FillArrUp;
            else if(Machine.DownArrow == "OUT")
                DOUT = FillArrDown;
            else
            {
                DIN = HollArrUp;
                DOUT = HollArrDown;
            }
        }
        
        //right arrows
	    if(CurrentGame.BrokenPort.search('R')<0)
	    {
	        if(Machine.RightArrow == "IN")
	            RIN = FillArrLeft;
            else if(Machine.RightArrow == "OUT")
                ROUT = FillArrRight;
            else
            {
                RIN = HollArrLeft;
                ROUT = HollArrRight;
            }
        }
	
        //left arrows
        if(CurrentGame.BrokenPort.search('L')<0)
        {
            if(Machine.LeftArrow == "IN")
                LIN = FillArrRight;
            else if(Machine.LeftArrow == "OUT")
                LOUT = FillArrLeft;
            else
            {
                LIN = HollArrRight;
                LOUT = HollArrLeft;
            }
        }
	}
	
	
	//hack to make the gui update
	let MPC = 0;
	let MCycles = 0;
	let MBak = 0;
	let MAcc = 0;
	let MIOAccess = 0;
	let MRight = "";
	let MLeft = "";
	let MUp = "";
	let MDown = "";
	
	
	function UpdateGUI()
	{
	    MPC = Machine.PC;
	    MCycles = Machine.Cycles;
	    MBak = Machine.Bak;
	    MAcc = Machine.Acc;
	    MIOAccess = Machine.IOAccess;
	    MRight = (Machine.Right != null ? String(Machine.Right) : " ");
	    MLeft = (Machine.Left != null ? String(Machine.Left) : " ");
	    MUp = (Machine.Up != null ? String(Machine.Up) : " ");
	    MDown = (Machine.Down != null ? String(Machine.Down) : " ");
	}

</script>

<style>
#coreall{
    background-color:#000000;
    color:#FFFFFF;
    font-weight:bold;
    font-size:16px;
    width:600px;
    /*height:500px;*/
    margin:auto auto;
    /*margin-top:50px;
    margin-bottom:50px;*/
    text-align: center;	
}
@import url("https://fonts.googleapis.com/css?family=VT323&display=swap");


textarea {
    background-color:#000000;
    color:#ffffff;
    font-family:"VT323",monospace;
    font-weight:bold;
    font-size:16px;
    text-transform:uppercase;
    resize: none;
    overflow:hidden;
    margin: 0 0 0 0;
}
/*#cpucore{
    position:relative;
    z-index:1;
}*/
/*.bordimg{
    position:absolute;
    left:-25px;
    top:-50px;
    z-index:-1;
}*/
#core{
    background-color:#000;
    color:#fff;
    border: 1px solid #fff;
    text-align:center;
    margin:auto auto;
}
.reg{
    border: 1px solid #fff;
    width:60px;
    height:40px;
    line-height: 25px;
}
.buts{
    height:60px;
    width:60px;
    color:#ffffff;
    background-color:#000000;
    font-size:16px;
	font-family: monospace; 
	font-weight:bold;
	cursor:pointer;
}
.buts_sym{ height:20px;width:20px;font-size:25px;
}

.cpulines{
    color:#FF0000;
}
/*#overlay {
    position: fixed; 
    display: none; 
    width: 400px; 
    height: 20px; 
    top: 0;
    left: 0;
    background-color: rgba(1,1,1,1); 
}*/
.port{
    font-size:30px;
}
</style> 





<Problem bind:COUT={COUT} CurrGame={CurrentGame} bind:UserU={UserU} bind:UserR={UserR} bind:UserD={UserD} bind:UserL={UserL}/>


<div id="coreall" >
    <div id="cpucore">
        <table align="center" style="padding:0px;">
            <tr><td></td><td></td><td style="height:20px;{UStyle}">{MUp}</td><td></td><td></td></tr>
            <tr><td></td><td></td><td class="port" style="{UStyle}">{@html UOUT} {@html UIN}</td><td></td><td></td></tr>
            <tr>
                <td style="width:25px;{LStyle}">{MLeft}</td>
                <td class="port" style="{LStyle}">{@html LIN}<br/>{@html LOUT}</td>
                <td>
                    <table id="core" cellpadding="0">
                        <tr>
                        <!-- Line Pointer -->
                        <td rowspan=5><textarea rows="16" cols="1" wrap="off" class="cpulines" charswidth="1" bind:value={LinePtr} id="CPULines"></textarea></td>
                        <!-- CODE -->
                        <td rowspan=5><textarea rows="16" cols="25" wrap="off" charswidth="25" bind:value={Program} id="CPUCode" spellcheck="false"></textarea></td>
                              
                        <td valign="top" class="reg">ACC<br/>{MAcc}</td>
                        </tr>
                        <tr><td valign="top" class="reg">BAK<br/>&lt;{MBak}&gt;</td></tr>
                        <!--<tr><td valign="top" class="reg">LAST<br/>{LASTVal}</td></tr>-->
                        <tr><td valign="top" class="reg">CYCLES<br/>{MCycles}</td></tr>
                        <tr><td valign="top" class="reg">I/O<br/>{MIOAccess}</td></tr>
                        <tr><td valign="top" class="reg">PC<br/>{MPC}</td></tr>
                    </table>
                </td>
                <td class="port" style="{RStyle}">{@html ROUT}<br/>{@html RIN}</td>
                <td style="width:25px;{RStyle}">{MRight}</td>
            </tr>
            <tr><td></td><td></td><td class="port" style="{DStyle}">{@html DIN} {@html DOUT}</td><td></td><td></td></tr>
            <tr><td></td><td></td><td style="height:20px;{DStyle}">{MDown}
            </td><td></td><td></td></tr>
        </table>
    </div>
</div>


<!--<Buttons/>-->

<table align="center" cellspacing="15">
	<tr>
		<td><button class="buts" on:click={StopBtn} id="stop_btn">
		    <span class="buts_sym">&#9632;</span><br/>STOP</button>
		</td>
		<td><button class="buts" on:click={StepBtn} id="step_btn">
		    <span class="buts_sym">&#9199;</span><br/>STEP</button>
		</td>
		<td><button class="buts" on:click={RunBtn} id="run_btn">
		    <span class="buts_sym">&#9654;</span><br/>RUN</button>
		</td>
		<td><div id="led_ind" class="led-red-off"></div></td>
		<!--<td><button class="buts"
		on:click={PwrBtn}>&#x23FB;<br/>POWER</button></td>--><!--fast &#9197;-->
	</tr>
</table>
